// Static interface copy in every supported app language. User and model content is not translated here.
import type { NamespaceCatalog } from '@/i18n/ns';

const en = {
  sent: 'Sent',
};

export type ChatChipCopyKey = keyof typeof en;

const copy: NamespaceCatalog<keyof typeof en> = {
  bg: {
    sent: 'Изпратено',
  },
  hr: {
    sent: 'Poslano',
  },
  cs: {
    sent: 'Odesláno',
  },
  da: {
    sent: 'Sendt',
  },
  nl: {
    sent: 'Verzonden',
  },
  en: {
    sent: 'Sent',
  },
  et: {
    sent: 'Saadetud',
  },
  fi: {
    sent: 'Lähetetty',
  },
  fr: {
    sent: 'Envoyé',
  },
  de: {
    sent: 'Gesendet',
  },
  el: {
    sent: 'Στάλθηκε',
  },
  hu: {
    sent: 'Elküldve',
  },
  ga: {
    sent: 'Seolta',
  },
  it: {
    sent: 'Inviato',
  },
  lv: {
    sent: 'Nosūtīts',
  },
  lt: {
    sent: 'Išsiųsta',
  },
  mt: {
    sent: 'Mibgħut',
  },
  pl: {
    sent: 'Wysłano',
  },
  pt: {
    sent: 'Enviado',
  },
  ro: {
    sent: 'Trimis',
  },
  sk: {
    sent: 'Odoslané',
  },
  sl: {
    sent: 'Poslano',
  },
  es: {
    sent: 'Enviado',
  },
  sv: {
    sent: 'Skickat',
  },
};
export default copy;
